<template>
    <el-button type="primary" size="small" v-bind="$attrs" v-on="$listeners" style="min-width: 80px;">
        <jj-icons type="switch" />
        <slot>
            {{ $t('buttons.switch') }}
        </slot>
    </el-button>
</template>
<script>
export default {
    name: 'ButtonSwitch'
}
</script>
